import { fetchWithTimeout, handleError, handleResponseError } from "./handlers"

export const updateYears = (token, years) => {
    return async (dispatch) => {
        const res = await fetchWithTimeout('/calendar/change/years/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body: JSON.stringify({ years })
        })

        if(res.ok) {
            const { response, years: result, data } = await res.json()
            if(response) dispatch(changeYears(result))
            else dispatch(handleError(data))
        } else
            dispatch(handleResponseError(res))
    }
}

export const fetchEvents = (token, year, month) => {
    return async (dispatch) => {
        const res = await fetchWithTimeout(`/events/${month}/${year}`, {
            headers: { 'Authorization': 'Bearer ' + token },
        });
        if(res.ok) {
            const { response, data } = await res.json()
            if(response) dispatch({ type: 'FETCH', events: data })
            else dispatch(handleError(data))
        } else
            dispatch(handleResponseError(res))
    }
}

export const fetchEvent = (token, id) => {
    return async (dispatch) => {
        const res = await fetchWithTimeout(`/event/${id}`, {
            headers: { 'Authorization': 'Bearer ' + token },
        });
        if(res.ok) {
            const { response, data } = await res.json()
            if(response) dispatch({ type: 'FETCH', event: data })
            else dispatch(handleError(data))
        } else
            dispatch(handleResponseError(res))
    }
}

export const changeYears = (years) => ({
    type: 'SET_YEARS',
    years
})

export const changeMonth = (month) => ({
    type: 'SET_MONTH',
    month
})

export const createEvent = (token, data, notify) => {
    return async (dispatch) => {
        const res = await fetchWithTimeout('/event', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body: JSON.stringify(data)
        }, notify)

        if(res.ok) {
            const { response, data: result } = await res.json()
            if(response) dispatch({ type: 'CREATE_EVENT', event: result })
            else dispatch(handleError(result))
        } else
            dispatch(handleResponseError(res))
    }
}

export const editEvent = (token, id, data, notify) => {
    return async (dispatch) => {
        const res = await fetchWithTimeout(`/event/${id}`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body: JSON.stringify(data)
        }, notify)

        if(res.ok) {
            const { response, data: result } = await res.json()
            if(response) dispatch({ type: 'EDIT_EVENT', event: result })
            else dispatch(handleError(result))
        } else
            dispatch(handleResponseError(res))
    }
}

export const deleteEvent = (token, id) => {
    return async (dispatch) => {
        const res = await fetchWithTimeout(`/event/${id}`, {
            method: 'DELETE',
            headers: { 'Authorization': 'Bearer ' + token },
        })

        if(res.ok) {
            const { response, data } = await res.json()
            if(response) dispatch({ type: 'DELETE_EVENT', uuid: data })
            else dispatch(handleError(data))
        } else
            dispatch(handleResponseError(res))
    }
}

export const initCalendar = (years, month) => ({
    type: 'INIT',
    month, years
})